import React from 'react';

import { useFormikContext, Formik, Form, Field } from 'formik';

import {FormMaterialTextField} from "shared-react/formik/FormikMaterialFields";

function FormField() {
    return (
        <Field
            name="username"
            label={'El. pašto adresas'}
            margin="dense"
            fullWidth
            component={FormMaterialTextField}
            nomargin={1}
        />
    );
}

export default FormField;